<template>

    <div>
        <card-table
            title="Selection"
            :items="units"
            :headers="tableHeaders"
            :controls="tableControls"
            :foundItems="filteredItems" >

            <template slot="cell" slot-scope="cellData">
                <a
                    class="btn btn-view border border-dark"
                    :href="buttonUrl + '/' + cellData.rowData.item.id"
                    v-if="buttonUrl != null" >
                    View
                </a>
            </template>

        </card-table>
    </div>

</template>

<script>

export default {

    props: {

        buttonUrl: {
            type: String,
            default: null,
        },

        units: {
            type: Array,
            required: true,
        }

    },

    data() {

        return {

            tableControls: {
                search: true,
                sort: true,
                itemsPerPage: 15,
            },

            tableHeaders: [
                { key: 'name', label: 'Name' },
                { key: 'type_description', label: 'Details' },
            ],

            filteredItems: [],
        };

    },

    watch: {

        filteredItems(){
            this.$emit("foundItems", this.filteredItems);
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/general-entities/GeneralEntitiesTable.vue